<template>
  <span
    v-if="grade"
    class="inline-flex items-center px-2 py-0.5 border rounded-full text-[12px] font-medium num bg-card"
    :style="{ borderColor: color, color }"
    :aria-label="$t('ui.gradeAria', { n: grade })"
  >T{{ grade }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { gradeAccentColor } from "../../utils/routeGrade";

const props = defineProps<{ grade: number | null | undefined }>();
const color = computed(() => (props.grade ? gradeAccentColor(props.grade) : "var(--ink)"));
</script>
